import React from 'react';
import ReactDOM from 'react-dom';
import MainPatient from './patient-lib/MainPatient';
import * as serviceWorker from './serviceWorker';
import "./index.css"
import { HashRouter, BrowserRouter } from 'react-router-dom';

ReactDOM.render(<BrowserRouter><MainPatient /></BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorker.register();
